import { configureStore } from "@reduxjs/toolkit";
import { paymentApi } from "./services/PaymentService";
import setDialogParams from '../store/feautures/DialogSlice';
import setDeleteParams from '../store/feautures/DeleteCardSlice';

export const store = configureStore({
  reducer: {
    setDialogParams,
    setDeleteParams,
    [paymentApi.reducerPath]: paymentApi.reducer
  },
  middleware: (gDM) => gDM().concat(paymentApi.middleware)
});

export type RootState = ReturnType<typeof store.getState>;